import { AnimatePresence, motion } from "framer-motion";
import { Route, Routes, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Footer from "./components/Footer";
import AdminLayout from "./components/admin/AdminLayout";
import Navbar from "./components/Navbar";
import About from "./pages/About";
import Account from "./pages/account/Account";
import AdminFaqs from "./pages/admin/AdminFaqs";
import AdminHome from "./pages/admin/AdminHome";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminOrderDetails from "./pages/admin/AdminOrderDetails";
import AdminOrders from "./pages/admin/AdminOrders";
import AdminProductForm from "./pages/admin/AdminProductForm";
import AdminProducts from "./pages/admin/AdminProducts";
import AdminPromoCodes from "./pages/admin/AdminPromoCodes";
import AdminPromoForm from "./pages/admin/AdminPromoForm";
import AdminSettings from "./pages/admin/AdminSettings";
import AdminTestimonials from "./pages/admin/AdminTestimonials";
import Cart from "./pages/Cart";
import Checkout from "./pages/Checkout";
import Contact from "./pages/Contact";
import DownloadRedirect from "./pages/DownloadRedirect";
import EbookDetails from "./pages/EbookDetails";
import Home from "./pages/Home";
import OrderSuccess from "./pages/OrderSuccess";
import ProductPage from "./pages/ProductPage";
import Shop from "./pages/Shop";

const pageTransition = {
  initial: { opacity: 0, y: 18 },
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: -18 },
  transition: { duration: 0.35, ease: "easeOut" },
};

function Page({ children }) {
  return (
    <motion.main {...pageTransition} className="page-shell">
      {children}
    </motion.main>
  );
}

export default function App() {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith("/admin");
useEffect(() => {
  console.log(
    "%c👋 Well, well... someone likes looking under the hood.",
    `
      color: #e63946;
      font-size: 15px;
      font-weight: 700;
      letter-spacing: 0.5px;
    `
  );

  console.log(
    "%cThis website was crafted with care by Hatem Elaraby.",
    `
      color: #555;
      font-size: 13px;
      font-weight: 500;
      line-height: 1.6;
    `
  );

  console.log(
    "%cIf you made it this far, you might like my work →",
    `
      color: #e63946;
      font-size: 13px;
      font-weight: 600;
      margin-top: 4px;
    `
  );

  console.log(
    "%chttps://main--hatemportofolio.netlify.app",
    `
      color: #e63946;
      font-size: 13px;
      font-weight: 700;
      text-decoration: underline;
    `
  );
}, []);
  return (
    <>
      {!isAdmin && <Navbar />}
      <AnimatePresence mode="wait">
        <Routes location={location} key={location.pathname}>
          <Route path="/" element={<Page><Home /></Page>} />
          <Route path="/shop" element={<Page><Shop /></Page>} />
          <Route path="/products/:slug" element={<Page><ProductPage /></Page>} />
          <Route path="/ebook" element={<Page><EbookDetails /></Page>} />
          <Route path="/about" element={<Page><About /></Page>} />
          <Route path="/contact" element={<Page><Contact /></Page>} />
          <Route path="/cart" element={<Page><Cart /></Page>} />
          <Route path="/checkout" element={<Page><Checkout /></Page>} />
          <Route path="/order-success" element={<Page><OrderSuccess /></Page>} />
          <Route path="/account" element={<Page><Account /></Page>} />
          <Route path="/download/:token" element={<Page><DownloadRedirect /></Page>} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<AdminHome />} />
            <Route path="products" element={<AdminProducts />} />
            <Route path="products/new" element={<AdminProductForm />} />
            <Route path="products/:id/edit" element={<AdminProductForm />} />
            <Route path="promocodes" element={<AdminPromoCodes />} />
            <Route path="promocodes/new" element={<AdminPromoForm />} />
            <Route path="promocodes/:id/edit" element={<AdminPromoForm />} />
            <Route path="orders" element={<AdminOrders />} />
            <Route path="orders/:id" element={<AdminOrderDetails />} />
            <Route path="settings" element={<AdminSettings />} />
            <Route path="testimonials" element={<AdminTestimonials />} />
            <Route path="faqs" element={<AdminFaqs />} />
          </Route>
        </Routes>
      </AnimatePresence>
      {!isAdmin && <Footer />}
    </>
  );
}
